import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatPaginator, MatTableDataSource } from '@angular/material';
import { FormControl } from '@angular/forms';
import { HCPCSAndNDCCodes, HCPCSCodes } from 'src/app/models/HCPCSCodes';
import { MasterService } from 'src/app/Services/Masters/master.service';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';

export interface DialogData {
  ndclistObj: HCPCSAndNDCCodes[];
}

@Component({
  selector: 'app-hcpcs-codes',
  templateUrl: './hcpcs-codes.component.html',
  styleUrls: ['./hcpcs-codes.component.css']
})
export class HcpcsCodesComponent implements OnInit {
  displayedColumns = ['Code', 'Description'];
  dataSource = new MatTableDataSource<HCPCSCodes>();
  filterValues = { codes: '', desc: '' };
  CodeFilter = new FormControl("");
  DescFilter = new FormControl("");
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor(public dialogRef: MatDialogRef<HcpcsCodesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
    , private masterservice: MasterService
    , private dialog: MatDialog) {
    this.GetAllBillingProviders();
  }

  ngOnInit() {
    this.CodeFilter.valueChanges.subscribe(Code => {
      this.filterValues.codes = Code;
      this.dataSource.filter = JSON.stringify(this.filterValues);
    });
    this.DescFilter.valueChanges.subscribe(Description => {
      this.filterValues.desc = Description;
      this.dataSource.filter = JSON.stringify(this.filterValues);
    });
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  onRowClick(ele: HCPCSCodes): void {
    //this.dialogRef.close(ele);
    var existList = this.data.ndclistObj.filter(x => x.HCPCSCode == ele.Code);
    if (existList.length > 0) {
      const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
        width: '300px',
        height: '170px',
        data: { headerText: "The HCPCS Code you've chosen is currently being utilized. Would you like to proceed with using the same HCPCS Code?" }
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result && result != undefined) {
          this.dialogRef.close(ele);
        }
      });
    } else {
      this.dialogRef.close(ele);
    }
  }

  hcpcscodeList: HCPCSCodes[] = [];
  async GetAllBillingProviders() {
    await this.masterservice.GetAllHCPCSCodes().subscribe(data => {
      this.hcpcscodeList = data;
      this.dataSource.data = this.hcpcscodeList;
      this.dataSource.filterPredicate = this.createFilter();
      this.dataSource.paginator = this.paginator;
    });
  }

  createFilter(): (data: any, filter: string) => boolean {
    let filterFunction = function (data, filter): boolean {
      let searchTerms = JSON.parse(filter);
      return (data.Code == null ? "" : data.Code).toLowerCase().indexOf(searchTerms.codes.toLowerCase()) !== -1
        && (data.Description === null ? "" : data.Description).toLowerCase().indexOf(searchTerms.desc.toLowerCase()) !== -1;
    }
    return filterFunction;
  }
}
